import { GetterTree } from 'vuex';
import { RootState } from '@/store/store';
import { ESearchGetters, ESearchState } from '@/content-library/search/store/search.constants';
import { ISearchState } from '@/content-library/search/store/search.types';
import { SearchHelper } from '@/content-library/search/helpers/search.helper';
import { ISearchItem } from '@/content-library/search/types/search';

export const getters: GetterTree<ISearchState, RootState> = {
  [ESearchGetters.RecentSearchItems]: (state: ISearchState): ISearchItem[] => {
    return SearchHelper.createRecentSearchItems(state[ESearchState.RecentSearches]);
  },
  [ESearchGetters.AutocompleteSearchItems]: (state: ISearchState): ISearchItem[] => {
    return SearchHelper.createAutocompleteSearchItems(state[ESearchState.AutocompleteSuggestions]);
  },
};
